<p-dialog [(visible)]="dealer" closable="false" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<fa-icon [icon]="['far', 'building']" class="me-4" size="lg"></fa-icon>
		{{ dealer.name }}
	</ng-template>

	<div class="d-flex flex-wrap">
		<mat-form-field class="w-100 mb-2">
			<mat-label>Dealer Name</mat-label>
			<input matInput #dealerName name="dealerName" [(ngModel)]="dealer.name" />
		</mat-form-field>
	</div>
	<div class="d-flex flex-wrap">
		<mat-form-field class="w-50 mb-2">
			<mat-label>Support Email</mat-label>
			<input matInput #supportEmail name="supportEmail" [(ngModel)]="dealer.supportEmail" />
		</mat-form-field>
		<mat-form-field class="w-50 mb-2">
			<mat-label>Support Phone</mat-label>
			<input matInput #supportPhone name="supportPhone" [(ngModel)]="dealer.supportPhone" />
		</mat-form-field>
	</div>
	<div class="d-flex flex-wrap">
		<mat-form-field class="w-50 mb-2">
			<mat-label>Admin Email</mat-label>
			<input matInput #adminEmail name="adminEmail" [(ngModel)]="dealer.adminEmail" />
		</mat-form-field>
		<mat-form-field class="w-50 mb-2">
			<mat-label>Admin Phone</mat-label>
			<input matInput #adminPhone name="adminPhone" [(ngModel)]="dealer.adminPhone" />
		</mat-form-field>
	</div>
	<div class="d-flex flex-column">
		<div class="h4">Dealer Users</div>
		<ng-container *ngFor="let user of dealerUsers" class="d-flex flex-column">
			<div class="p-grid border-bottom">
				<div class="p-col">
					<div class="d-flex flex-column">
						<div class="">{{ user.firstName }} {{ user.lastName }}</div>
						<div class="mx-2">
							<i>{{ user.email }}</i>
						</div>
						<div class="mx-2">
							<i>{{ user.phone }}</i>
						</div>
					</div>
				</div>
				<div class="p-col">
					<div class="d-flex flex-column">
						<mat-checkbox class="" [(ngModel)]="user.notificationsEmail" (change)="changedUsers.push(user)">Email Notification</mat-checkbox>
						<mat-checkbox class="" [(ngModel)]="user.notifiationsSms" (change)="changedUsers.push(user)" [disabled]="!user.phone"
							>SMS Notification</mat-checkbox
						>
					</div>
				</div>
			</div>
		</ng-container>
	</div>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]="true"
			[hideSave]=""
			(onCancelChange)="onClose()"
			(onDeleteChange)="(undefined)"
			(onSaveChange)="onSave()"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]=""
		></app-record-control-footer>
	</ng-template>
</p-dialog>
